import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export default function SearchMatch({ match }) {
    const { t } = useTranslation();
    const term = useSelector(state => state.filters.submittedSearchCriteria);
    const active = useSelector(state => state.filters.search);
    if (!active || !match || !['specification', 'description'].includes(match.type)) return null;
    const words = (term || '').trim().split(/\s+/).filter(Boolean)
        .map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const pattern = words.length ? new RegExp(`(${words.join('|')})`, 'giu') : null;
    const parts = pattern ? match.text.split(pattern) : [match.text];
    return <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
        {t(`searchMatch.${match.type}`)}{': '}
        {parts.map((part, index) => index % 2 ? <mark key={index}>{part}</mark> : part)}
    </Typography>;
}
